import React from "react";
import { ThemedBottomNavView } from "./view";
import { styles } from "./styles";

export class ThemedBottomNav extends React.Component {
  render() {
    return <ThemedBottomNavView {...this.props} styles={styles} />;
  }
}
